module.exports = __webpack_public_path__ + "img/flechader2.86b303df.png";